import {connect} from 'react-redux';
import {createStructuredSelector} from 'reselect';

import {userId} from '/redux/selector/currentUser.selector';
import {
  performanceAboveRankById,
  performanceAtRankById,
  performanceBelowRankById,
} from '/redux/selector/metric.teams.selector';
import {withProps} from '/util/selector.util';

import RankPerformanceSection from './RankPerformanceSection';

const withCoachUserId = withProps({coachId: userId});

export default connect(
  createStructuredSelector({
    aboveRank: withCoachUserId(performanceAboveRankById),
    atRank: withCoachUserId(performanceAtRankById),
    belowRank: withCoachUserId(performanceBelowRankById),
  }),
)(RankPerformanceSection);
